import { getAccessToken } from '~/utils/token'
import client from '~/api/client'

function bearer(): string | null {
  return getAccessToken()
}

/**
 * Raw `fetch` with the user's JWT and ONE refresh-and-retry on 401 — for the
 * callers that cannot go through the typed `client` (full URLs, multipart).
 * The access token lives 30 min; the inline-edit write endpoints
 * (`/api/web-block/{id}/…`, `/api/block/{id}/…`) answer 401 to an expired
 * JWT, and only the `client` middleware knows how to refresh it — so a cheap
 * `client` call triggers the refresh, then the request is replayed.
 */
export async function authedFetch(url: string, init: RequestInit = {}): Promise<Response> {
  const send = () => {
    const headers = new Headers(init.headers || {})
    const t = bearer()
    if (t) headers.set('Authorization', `Bearer ${t}`)
    return fetch(url, { ...init, headers })
  }
  let res = await send()
  if (res.status === 401 && bearer()) {
    await client.GET('/api/auth/me').catch(() => null)
    res = await send()
  }
  return res
}
